module.exports = __webpack_public_path__ + "img/img7.dbd37bb1.png";